export const MuiListItemButton = {
  styleOverrides: {
    root: {
      margin: '4px',
      padding: '4px 12px',
      borderRadius: '8px',
      '&.Mui-selected': {
        color: 'rgb(88, 166, 255)',
      },
      '&.Mui-selected .MuiTypography-root': {
        color: 'rgb(88, 166, 255)',
        fontWeight: '600',
      },
    },
  },
}
